import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Friendly full-page overlay shown while the API is waking from idle/sleep.
 * Designed to match the Shot to the Nines brand palette.
 */
export const WakingOverlay = () => (
  <div
    className="fixed inset-0 z-50 bg-[#F5F1E8] flex items-center justify-center p-6"
    data-testid="api-waking-overlay"
  >
    <div className="text-center max-w-md">
      <div className="mx-auto w-16 h-16 rounded-full bg-[#C9A961]/20 flex items-center justify-center mb-6">
        <Loader2 className="w-8 h-8 text-[#C9A961] animate-spin" />
      </div>
      <h2 className="text-3xl font-serif italic text-[#8B7355] mb-3">
        Just a moment
      </h2>
      <p className="text-[#8B7355]/80 leading-relaxed">
        Waking up the server &mdash; this usually takes 5 to 10 seconds the
        first time after a quiet period.
      </p>
      <p className="text-sm text-[#8B7355]/60 mt-4 italic">
        Don&apos;t close this tab.
      </p>
    </div>
  </div>
);
